import { ApiFunc, getInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const iconference: ApiFunc<`${typeof API.ICONFERENCE}{id}`, 'get'> = data =>
  instance.get(`${API.ICONFERENCE}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const iconferenceCreate: ApiFunc<`${typeof API.ICONFERENCE}`, 'post'> = data =>
  instance.post(API.ICONFERENCE, data)

export const iconferenceAll: ApiFunc<`${typeof API.ICONFERENCE_ALL}`, 'get'> = data =>
  instance.get(API.ICONFERENCE_ALL, { params: data })

export const iconferenceAllFilter: ApiFunc<`${typeof API.ICONFERENCE_ALL_FILTER}`, 'get'> = data =>
  instance.get(API.ICONFERENCE_ALL_FILTER, { params: data })

export const iconferenceArticleList: ApiFunc<`${typeof API.ICONFERENCE_ARTICLE_LIST}`, 'get'> = data =>
  instance.get(API.ICONFERENCE_ARTICLE_LIST, { params: data })

export const iconferenceArticleAll: ApiFunc<`${typeof API.ICONFERENCE_ARTICLE_ALL}`, 'get'> = data =>
  instance.get(API.ICONFERENCE_ARTICLE_ALL, { params: data })

export const iconferenceMagazineArticle: ApiFunc<`${typeof API.ICONFERENCE_MAGAZINE_ARTICLE}`, 'get'> = data =>
  instance.get(API.ICONFERENCE_MAGAZINE_ARTICLE, { params: data })

export const iconferenceCategoryAll: ApiFunc<`${typeof API.ICONFERENCE_CATEGORY_ALL}`, 'get'> = data =>
  instance.get(API.ICONFERENCE_CATEGORY_ALL, { params: data })

export const iconferenceArticle: ApiFunc<`${typeof API.ICONFERENCE_ARTICLE}{id}`, 'get'> = data =>
  instance.get(`${API.ICONFERENCE_ARTICLE}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const iconferenceArticleStep: ApiFunc<`${typeof API.ICONFERENCE_ARTICLE_STEP}`, 'post'> = data =>
  instance.post(API.ICONFERENCE_ARTICLE_STEP, data)

export const iconferenceArticleProof: ApiFunc<`${typeof API.ICONFERENCE_ARTICLE_PROOF}`, 'post'> = data =>
  instance.post(API.ICONFERENCE_ARTICLE_PROOF, data)
